import MagicIconSVG from '../../assets/MagicIconSVG';
import AppTipsComponents from '../../CommonComponents/AppTipsUI/AppTipsUI';
import InlineStyled from '../../CommonComponents/InlineStyled/InlineStyled';

const docChatTips = [
  {
    id: '1',
    text: (
      <>
        Upload your document(s), enter your query in <b>Ask DocChat</b>, and click{' '}
        <b className='color-primary'>Start DocChat</b>. You can also upload first, click Start
        DocChat and then ask your query in chat.
      </>
    ),
  },
  {
    id: '2',
    text: (
      <>
        Click{' '}
        <span className='app-gradient-text inline-flex align-center gap-2'>
          <b>MikeLegal's Magic</b>
          <MagicIconSVG size={16} />
        </span>{' '}
        and select an action from the dropdown to run our ready-made preset prompts.
      </>
    ),
  },
  {
    id: '3',
    text: (
      <>
        Click <b>Your Workflows</b> and choose a workflow from the dropdown to run your custom
        extraction prompt.
      </>
    ),
  },
  {
    id: '4',
    text: (
      <>
        To create your own workflow, go to{' '}
        <b>
          Profile &gt; Settings &gt; Workflows &gt;{' '}
          <span className='color-primary'>Create New Workflow.</span>
        </b>{' '}
        You can also click <b className='color-primary'>Create New Workflow</b> in the Chat Window -
        it will redirect you to Settings to complete the same setup.
      </>
    ),
  },
];

const FileUploadTips = () => {
  return (
    <InlineStyled style={{ maxWidth: '750px', margin: '0 auto' }}>
      <AppTipsComponents>
        <InlineStyled
          as='ol'
          $style={{
            paddingLeft: 18,
            display: 'flex',
            flexDirection: 'column',
            gap: 8,
          }}
        >
          {docChatTips.map((tip) => (
            <InlineStyled
              key={tip.id}
              as='li'
              $style={{
                color: '#465364',
                fontSize: 14,
                lineHeight: 'normal',
                listStyleType: 'decimal',
                paddingLeft: 3,
              }}
            >
              {tip.text}
            </InlineStyled>
          ))}
        </InlineStyled>
      </AppTipsComponents>
    </InlineStyled>
  );
};

export default FileUploadTips;
